import queryString from 'qs';

const historySupported = !!window.history && !!history.pushState;
const searchForm = $("[data-product-search='form']");
const results = $("[data-product-search='results']");
const clearAll = $("[data-product-search='clear-all']");
let searching = false;
let searchRequested = false;
let ignoreFormChanges = false;
let executeSearchTimer = null;
let lastHistoryQuery = null; // simple half-solution to preventing doubling up of history

function updateFormFromData(qs) {
  const data = queryString.parse(qs);
  const t = data.t || [];
  const selectedTags = typeof t == 'object' ? t : [t];

  ignoreFormChanges = true;
  try {
    searchForm.find("[name='q']").val(data.q || '');
    searchForm.find("input[type='checkbox'][name='t']").each((i, item) => {
      item.checked = $.inArray(item.getAttribute('value'), selectedTags) > -1;
    });
  } finally {
    ignoreFormChanges = false;
  }
}

function _executeSearch({query = null, ephemeral = false, updateForm = false} = {}) {
  const data = query || searchForm.serializeArray();
  const dataQueryString = typeof query == 'string' ? data : $.param(data);

  if (historySupported && !ephemeral && dataQueryString != lastHistoryQuery) {
    lastHistoryQuery = dataQueryString; // assumes that $.param is consistent
    history.pushState({productSearch: {query: data}}, '', '?' + dataQueryString)
  }

  if (updateForm) {
    updateFormFromData(dataQueryString);
  }

  if (!searching) {
    searching = true;
    searchRequested = false;

    results.addClass('loading-spinner-before');
    $.ajax({
      method: 'get',
      url: '?',
      data: data,
      dataType: 'json',
      success: data => {
        document.title = data.title;
        results.hide();
        results.html(data.contents);
        results.fadeIn(100);
        bindResults();
      },
      error: () => {
        searchForm.unbind('submit.productSearch');
        searchForm.submit();
      },
      complete: () => {
        results.removeClass('loading-spinner-before');
        searching = false;
        if (searchRequested) {
          executeSearch();
        }
      }
    });
  } else {
    searchRequested = true;
  }
}

function executeSearch() {
  clearTimeout(executeSearchTimer);
  // Give a small delay in case we need to reset a bunch of inputs or something
  executeSearchTimer = setTimeout(_executeSearch.bind(null, ...arguments), 1);
}

function bindResults({initial = false} = {}) {
  results.find('.pagination-buttons a').bind('click', function (event) {
    event.preventDefault();
    const href = this.getAttribute('href');
    const m = href.match(/\?(.*)$/);
    if (m) {
      executeSearch({query: m[1]});
      $('html, body').scrollTop(results.offset().top - 100);
    }
  });

  const sortForm = results.find("[data-product-search='sort-form']");
  sortForm.find('select').bind('change', event => {
    executeSearch({query: sortForm.serializeArray()});
  });
  sortForm.bind('submit', function (event) {
    event.preventDefault();
  });
  sortForm.find("[data-product-search='sort-form-submit']").remove();

  if (!initial && window.softwareDownloadClick) {
    results.find('.software-download-button,.modal-button').click(softwareDownloadClick);
    results.find('.truncated-text').bind("click", function (event) {
      event.preventDefault();
      const $this = $(this);
      $this.hide();
      $this.next('.full-text').show();
    });
  }
}

searchForm.bind('submit.productSearch', event => {
  event.preventDefault();
});

clearAll
  .bind('click', event => {
    event.preventDefault();
    searchForm.find("input[type='checkbox']").each((i, item) => {
      item.checked = false;
    });
    searchForm.find("input[type='text'], input[type='search'], select").val('');
    executeSearch();
  })
  .bind("dblclick", event => event.preventDefault());

searchForm.find("input, select").bind("change", function (event) {
  if (!ignoreFormChanges) {
    if (this.getAttribute('type') == 'checkbox' || this.productSearchLastValue != this.value) {
      this.productSearchLastValue = this.value;
      executeSearch();
    }
  }
});

searchForm.find("input").bind("keyup", function () {
  if (!ignoreFormChanges) {
    if (this.productSearchLastValue != this.value) {
      this.productSearchLastValue = this.value;
      if (this.productSearchTypeTimer) {
        clearTimeout(this.productSearchTypeTimer);
      }
      this.productSearchTypeTimer = setTimeout(() => executeSearch(), 500);
    }
  }
});

// History complexity because old versions of Chrome and Safari popstate on page load
window.addEventListener('load', function () {
  setTimeout(function () {
    window.addEventListener('popstate', event => {
      if (event.state && event.state.productSearch && event.state.productSearch.query) {
        lastHistoryQuery = event.state.productSearch.query;
        executeSearch({query: event.state.productSearch.query, ephemeral: true, updateForm: true});
      }
    });
  }, 0);
}, false);

const data = searchForm.serializeArray();
const dataQueryString = typeof query == 'string' ? data : $.param(data);
if (historySupported && dataQueryString != lastHistoryQuery) {
  history.replaceState({productSearch: {query: data}}, '', '?' + dataQueryString)
}

$("[data-product-search='clear'], [data-product-search='submit']").remove();

bindResults({initial: true});

setTimeout(() => {
  searchForm.find("input[name='q']").focus().select();
}, 5);